import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {find} from 'lodash';
import {reduxForm, formValueSelector} from 'redux-form';
import {Card, Grid, Button, Dropdown, Icon, Form} from 'semantic-ui-react';
import {noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {QUALITY_ASSURANCE_ORDERS_FORM} from '../../../common/forms';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import CommentsByChassis from './comment';
import CreateForm from './form';
import './create.scss';

class QualityControlOrderCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'chassisTmp': '',
      'chassisSelected': '',
      'chassisInfo': {},
    };
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.QualityAssuranceOrders,
        scopes.Create
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchJDEParameters();
    this.props.fetchTechnicians({'action': 'create_quality_assurance_order'});
    this.props.fetchDealers('importers');
    this.props.fetchChassisForQualityAssuranceOrders();
  }

  onCancelClick() {
    this.props.navigateBack();
  }

  async onSubmit(formValues) {
    if (formValues.requiresInspection === 'yes' && !formValues.responsible) {
      return;
    }
    const formValuesFormatted = {...formValues};
    formValuesFormatted.chassis = this.state.chassisSelected;
    if (formValues.requiresInspection === 'no' && formValues.responsible) {
      formValuesFormatted.responsible = '';
    }
    if (formValues.workStartDate) {
      formValuesFormatted.workStartDate = moment(
        formValues.workStartDate
      ).format(noTimeZoneShortISODate);
    }
    if (formValues.deliveryDate) {
      formValuesFormatted.deliveryDate = moment(formValues.deliveryDate).format(
        noTimeZoneShortISODate
      );
    }
    delete formValuesFormatted.status;
    delete formValuesFormatted.tasks;
    delete formValuesFormatted.parts;

    await this.props.createForQualityAssuranceOrder(formValuesFormatted);
    this.props.navigateBack();
  }

  getChassisOptions() {
    const {chassisList} = this.props;
    return chassisList.map((item) => {
      return {'value': item.chassis, 'text': item.chassis};
    });
  }

  onChangeTemporalValues(value, field) {
    const newState = {};
    newState[`${field}Tmp`] = value;
    this.setState(newState, () => this.updateDataSelected(field));
  }

  updateDataSelected(field) {
    const {chassisList} = this.props;
    const temporalValue = this.state[`${field}Tmp`];
    const selectedValue = this.state[`${field}Selected`];

    if (selectedValue === temporalValue) {
      return;
    }

    const chassisInfo = find(chassisList, {'chassis': temporalValue});

    const newState = {chassisInfo};
    newState[`${field}Selected`] = temporalValue;
    this.setState(newState);
    this.props.fetchingCommentsOtherOrdersByChassis(temporalValue);
  }

  getExternalColorName() {
    const {outdoorColorList} = this.props;
    const {chassisInfo} = this.state;
    if (!chassisInfo.outDoorColor) {
      return '';
    }
    const color = find(outdoorColorList, {'name': chassisInfo.outDoorColor});
    return color && color.description ? color.description : '';
  }

  renderValue(label, isTitle) {
    return isTitle ? <h4>{label}</h4> : label;
  }

  renderColumnData(width, label, isTitle = false) {
    return (
      <Grid.Column width={width}>
        {this.renderValue(label, isTitle)}
      </Grid.Column>
    );
  }

  renderChassisInfo() {
    const {user} = this.props;
    const {chassisInfo} = this.state;
    return (
      <Grid.Row>
        {this.renderColumnData(1, 'Katashiki:', true)}
        {this.renderColumnData(
          3,
          chassisInfo.katashiki ?
            `${chassisInfo.sfx} / ${chassisInfo.katashiki}` :
            '',
          false
        )}
        {this.renderColumnData(1, 'Modelo:', true)}
        {this.renderColumnData(3, chassisInfo.model, false)}
        {this.renderColumnData(1, 'Color:', true)}
        {this.renderColumnData(3, this.getExternalColorName(), false)}
        {this.renderColumnData(1, 'Asesor:', true)}
        {this.renderColumnData(3, user.toUpperCase(), false)}
      </Grid.Row>
    );
  }

  renderFilterDates() {
    const {
      loadingChassis,
      submitting,
      invalid,
      requiresInspection,
      responsible,
    } = this.props;
    const {chassisTmp, chassisSelected} = this.state;
    const responsibleIsRequired =
      requiresInspection === 'yes' && !responsible ? true : false;
    return (
      <Grid textAlign='left'>
        <Grid.Row>
          <Grid.Column width={1} className='label'>
            <h4>Chasis</h4>
          </Grid.Column>
          <Grid.Column width={3}>
            <Dropdown
              value={chassisTmp}
              options={this.getChassisOptions()}
              selection
              search
              loading={loadingChassis}
              disabled={loadingChassis}
              noResultsMessage='Chasis no encontrado'
              onChange={(e, {value}) =>
                this.onChangeTemporalValues(value, 'chassis')
              }
              style={
                !chassisTmp ?
                  {'borderColor': 'red', 'backgroundColor': '#fff5f6'} :
                  null
              }
            />
          </Grid.Column>
          <Grid.Column width={12} textAlign='right'>
            <Button
              type='button'
              secondary
              onClick={this.onCancelClick}
              disabled={submitting}
            >
              Cancelar
            </Button>
            <Button
              primary
              disabled={
                submitting ||
                invalid ||
                !chassisSelected ||
                responsibleIsRequired
              }
            >
              Crear
            </Button>
          </Grid.Column>
        </Grid.Row>
        {this.renderChassisInfo()}
      </Grid>
    );
  }

  render() {
    const {handleSubmit, submitting, loading, comments} = this.props;
    const {chassisSelected} = this.state;
    return (
      <Form
        className='quality-assurance-orders-create-form'
        onSubmit={handleSubmit(this.onSubmit)}
        loading={submitting}
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick} />
              <h2>Crear Orden Control de Calidad</h2>
            </div>
            <div className='filters-section'>{this.renderFilterDates()}</div>
          </div>
        </Card>

        <CreateForm chassis={chassisSelected} />

        {chassisSelected && <CommentsByChassis loading={loading} comments={comments} />}
      </Form>
    );
  }
}

export {QualityControlOrderCreate};

const form = reduxForm({
  'form': QUALITY_ASSURANCE_ORDERS_FORM.name,
})(QualityControlOrderCreate);

const mapStateToProps = (state) => {
  const selector = formValueSelector(QUALITY_ASSURANCE_ORDERS_FORM.name);
  const requiresInspection = selector(state, 'requiresInspection');
  const responsible = selector(state, 'responsible');

  return {
    requiresInspection,
    responsible,
    'loadingChassis': state.qualityAssuranceOrders.loadingChassis,
    'chassisList': state.qualityAssuranceOrders.chassisList,
    'outdoorColorList': state.qualityAssuranceOrderCreate.outdoorColorList,
    'loading': state.qualityAssuranceOrderCreate.loadingCommentsByChassis,
    'comments': state.qualityAssuranceOrderCreate.commentsByChassis,
    'user': state.session.user,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  navigateBack,
  fetchJDEParameters,
  fetchTechnicians,
  fetchDealers,
  fetchChassisForQualityAssuranceOrders,
  createForQualityAssuranceOrder,
  fetchingCommentsOtherOrdersByChassis,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  navigateBack,
  fetchJDEParameters,
  fetchTechnicians,
  fetchDealers,
  fetchChassisForQualityAssuranceOrders,
  createForQualityAssuranceOrder,
  fetchingCommentsOtherOrdersByChassis,
})(form);
